module.exports = "/_next/static/images/my-homecredit-app-5287db09d433b4e1c87dd4f451797559.png";